import Vue from 'vue'
import Vuex from 'vuex'
// chamadas a API
import requests from "../requests/api";
// constantes do sistema
import constants from "../constants/index";
import _ from  'lodash';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        msgs: {},
        count: 0,
        requests: requests,
        constants: constants,
    },
    mutations: {   
        add_msgs(state, {ref, msg, variant}) {
            msg = Vue.prototype.$helper.getMsg(msg);
            if(msg.length) {
                if(!this.state.msgs[ref])
                    Vue.set(this.state.msgs, ref, {});
                //obtém as mensagens da referida caixa de mensagem para a classe de contexto (variant)
                let msgs = this.state.msgs[ref][variant] || [];
                //adiciona as novas mensagens 
                Vue.set(this.state.msgs[ref], variant, _.concat(msgs, msg));
            }
        },
        flush_msgs(state, {ref, variant}) {
            let msgs = this.state.msgs[ref];
            if(msgs) {
                if(variant) Vue.delete(this.state.msgs[ref], variant);//de uma classe específica
                else Vue.delete(this.state.msgs, ref);//de todas as classes
            }
        },
        increment(state) {
            state.count++
        } 
    },
  
    actions: {
       
        addErro({ commit }, {ref, msg, variant="warning"}) {
            commit('add_msgs', {ref, msg, variant});
        },
        addSucesso({ commit }, {ref, msg, variant="success"}) {
            commit('add_msgs', {ref, msg, variant});
        },
        addMsgs({ commit }, {ref, msg, variant="info"}) {
            commit('add_msgs', {ref, msg, variant});
        },
        flushErro({ commit }, ref) {
            commit('flush_msgs', {ref, variant: 'warning'});
        },
        flushSucesso({ commit }, ref) {
            commit('flush_msgs', {ref, variant: 'success'});
        },
        flushMsgs({ commit }, obj) {
            obj = typeof obj === 'object' ? obj : {ref: ''+obj};
            commit('flush_msgs', obj);
        },
        
    },
   
    getters: {
        itensBreadcrumb: state => {
            return state.itensBreadcrumb
        },
    
        msgsByRef: (state) => (ref, variant = null) => {
            return state.msgs[ref]
            ? (variant ? state.msgs[ref][variant] : state.msgs[ref])
            : null
        },
        http: state => state.requests, 
        const: state => state.constants        
    }
   
})
